module.exports = __webpack_public_path__ + "static/Milan_Misak_To_starnuti-2c771f6aba272c4ba7b93aeecc6ec6cb.mp3";